/**
 * @param obj1 is the first object to compare
 * @param obj2 is the second object to compare
 * @returns This function compares two objects and return true if all the keys in the first object are present and are equal in the second one, else returns false
 */
export const objectComparision = <T extends Record<string, any>, U extends Partial<T>>(obj1: T, obj2: U): boolean => {
  return (Object.keys(obj2) as (keyof U)[]).every((key) => obj1[key as keyof object] === obj2[key]);
};
